import ControllerBase from '../../../../global/js/ControllerBase';

export default class ControllerPressHeadline extends ControllerBase {

	private header;
	private headerNav;
	private headerHeight = 0;

	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private init(): void {
		const body = document.body as HTMLElement;
		body ? body.classList.add('mediacenter-detail') : null;
		this.headerElement();
	}

	private headerElement() {
		this.header = document.querySelector('header.o-nav') as HTMLElement;
		if (this.header) this.header.classList.add('black-background');
		this.headerNav = document.querySelector('header >.m-nav-bar') as HTMLElement;
		if (this.headerNav) {
			this.heightControll();
			window.addEventListener('resize', () => this.heightControll());
		}
	}

	private heightControll() {
		this.headerHeight = this.headerNav?.clientHeight as number;
		this.$element.style.paddingTop = `${this.headerHeight || 0}px` as string;
	}
}
